import { Controller } from '@hotwired/stimulus'

const FALLBACK_ACTIVE_CLASSES = ['border-blue-600', 'text-blue-600']
const FALLBACK_INACTIVE_CLASSES = ['border-transparent', 'text-gray-500']

export default class extends Controller {
  static targets = ['link', 'panel']
  static classes = ['active', 'inactive']
  static values = { param: { type: String, default: 'tab' } }

  connect() {
    this.#activate(this.#initialPanelName())
  }

  switch(event) {
    const name = event.params.panel
    this.#activate(name)
    this.#syncQueryString(name)
  }

  #activate(name) {
    if (!name) return

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.panel !== name)
    })

    const activeClasses = this.hasActiveClass ? this.activeClasses : FALLBACK_ACTIVE_CLASSES
    const inactiveClasses = this.hasInactiveClass ? this.inactiveClasses : FALLBACK_INACTIVE_CLASSES

    this.linkTargets.forEach((link) => {
      const active = link.dataset.panel === name
      link.classList.remove(...(active ? inactiveClasses : activeClasses))
      link.classList.add(...(active ? activeClasses : inactiveClasses))
      link.setAttribute('aria-selected', active ? 'true' : 'false')
    })
  }

  #initialPanelName() {
    const fromQuery = new URLSearchParams(window.location.search).get(this.paramValue)
    if (fromQuery && this.panelTargets.some((p) => p.dataset.panel === fromQuery)) {
      return fromQuery
    }

    const first = this.panelTargets[0]
    return first ? first.dataset.panel : null
  }

  #syncQueryString(name) {
    const url = new URL(window.location.href)
    url.searchParams.set(this.paramValue, name)
    window.history.replaceState({}, '', url)
  }
}
